export default "__VITE_ASSET__B1Yogj3p__"